import styled, { css } from 'styled-components';
import { th, zIndexes, variants } from 'style/theme';
import { sizes } from 'style';

export const Info = styled.div`
  position: absolute;
  top: 0;
  left: ${(p) => (p.left ? '-253px' : 'calc(100% + 6px)')};
  background: ${th('colors.black')};
  color: ${th('colors.white')};
  font-weight: 400;
  font-size: ${th('fontSizes.2')}px;
  text-align: left;
  padding: 10px;
  line-height: 19px;
  width: 200px;
  top: 0;
  left: ${(p) => (p.left ? '-253px' : '28px')};
  z-index: ${zIndexes.dropdown};
  border-radius: 5px;
  font-family: ${th('fonts.body')};
  opacity: 0;
  display: none;
  visibility: hidden;
  user-select: text;
  box-shadow: 0px 3px 6px #00000029;
  cursor: auto;

  @media ${sizes.tabletLandscape} {
    ${variants('infoSize', {
      wide: css`
        width: 300px;
      `
    })}
  }

  @media ${sizes.desktop} {
    display: block;
  }

  ${variants('variant', {
    rh: css`
      padding: 16px;
      width: 224px;
      line-height: 16px;
      font-size: 12px;
      left: 50%;
    `
  })}

  ${variants('size', {
    tiny: css`
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      /* or 133% */
      letter-spacing: -0.01em;
    `
  })}
`;

export const Container = styled.span`
  ${variants('variant', {
    light: css`
      opacity: 0.5;

      :hover {
        opacity: 1;
      }
    `
  })}

  ${variants('size', {
    normal: css`
      width: 20px;
      height: 20px;

      > img {
        width: 20px;
        height: 20px;
      }
    `,
    small: css`
      width: 16px;
      height: 16px;

      > img {
        width: 16px;
        height: 16px;
      }
    `,
    tiny: css`
      width: 12px;
      height: 12px;

      > img {
        width: 12px;
        height: 12px;
      }
    `
  })}

  position: relative;

  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  user-select: none;
  margin-left: 8px;
  vertical-align: ${({ verticalAlign }) => verticalAlign};

  > svg {
    width: 20px;
    height: 20px;

    ${variants('variant', {
      light: css`
        color: ${th('colors.white')};
      `,
      dark: css`
        color: ${th('colors.black')};
      `,
      grey: css`
        color: ${th('colors.black')}50;
      `
    })}
  }

  @media ${sizes.desktop} {
    &:hover {
      > ${Info} {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.25s;
      }
    }
  }
`;

export const TextTooltipContainer = styled.span`
  position: relative;

  @media ${sizes.desktop} {
    &:hover {
      > ${Info} {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.25s;
      }
    }
  }
`;

export const UnderlineText = styled.span`
  font-weight: bold;
  border-bottom: 1px dashed currentcolor;
`;

export const List = styled.ul`
  padding-left: 15px;
  margin: 0;
  width: 100%;
  > li {
    margin: 0 0 2px 0;
    &:last-child {
      margin: 0;
    }
  }
`;
